<template>
  <div id="signContract_warpper">
    <nav-bar titleText="电子合同" titleWeight="bold" @goBack="goBack"></nav-bar>
    <div class="stepper-warpper">
      <van-stepper
        v-model="value"
        input-width="40px" 
        step="0.2"
        :decimal-length="1"
        :disabled="isDisabled"
        @change="stepperOnchange"
      />
      <div class="percent">{{percentValue}}</div>
    </div>
    <div class="contentBox">
      <div id="contidract" :style="contidractStyle" ref="contidract">
        <!-- <img width="100%" height="100%" src="../../../assets/debtor/user.png" /> -->
        <div :style="pdfStyle" ref="pdfbox">
          <pdf
            v-for="i in numPages" 
            :key="i" 
            :src="pdfSrc" 
            :page="i" 
            ref="pdfs" 
            @loaded="pdfLoaded(i)"
            :style="{width: '100%'}"
          >
          </pdf>
        </div>

      </div>
    </div>
    <div id="signBox">
      <div class="complete">
        <van-button @click="handleSignClick" type="primary" class="operation_btn" :disabled="!checkSign">确定</van-button>
      </div>
    </div>
    <van-dialog
      v-model="show"
      title="签署校验"
      confirmButtonColor="#F9591B"
      show-cancel-button
      @confirm="phoneConfirm"
    >
      <div class="modal">
        <van-row class="user-links">
          <van-cell-group>
            <van-field
              class="mobile"
              v-model="phone"
              placeholder="请输入手机号"
              type="number"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="12"
              disabled
            />
            <van-field
              class="codeBox"
              v-model="msg"
              placeholder="请输入短信验证码"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="6"
            >
              <van-button
                slot="button"
                class="verification_code"
                size="small"
                @click="getvarify"
                v-if="downcounttime == 0"
              >获取验证码</van-button>
              <van-button
                class="downcount"
                slot="button"
                size="small"
                v-if="downcounttime == 1"
              >{{down}}s后获取</van-button>
            </van-field>
          </van-cell-group>
        </van-row>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showDialog2"
      message="合同审核中，请稍等"
      confirm-button-text="返回首页"
      confirm-button-color="#F9591B"
      @confirm="goHome"
    ></van-dialog>
    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar"
import axios from "axios"
import pdf from "vue-pdf"
import Bus from "../../../providers/eventBus"
export default {
  name: "signContract",
  data() {
    return {
      value: 1,
      showPdf: false,
      contidractStyle: {'background-color': '#E3E3E3', height: '400px'},
      show: false,
      dialogShow:false,
      showDialog2: false,
      phone: "",
      msg: "",
      phontCorrect: 0,
      down: 60,
      downcounttime: 0,
      spacePop: false,
      getVerifyNum: 0,
      stopGet: "",
      flag: 0,
      close_ClickOverlay: false,
      sealKey: "",
      pdfSrc: "",
      pdfStyle: {'transform-origin': 'left top'},
      divSign1: {},
      divSign2: {},
      divSign3: {},
      numPages: undefined,
      checkSign: false,
      img_file: '',
      img_name: '',
      isCompany: false,
      seal_url: '',
      isDisabled: false,
      lock: false,
      loading: false,
    };
  },
  created() {
    Bus.$on('busSignature', this.handleBusSignature)
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    // this.handleInput();
    if (/Android/gi.test(navigator.userAgent)) {
      window.addEventListener("resize", function () {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView(false);
        }, 1);
      });
    }
    this.isCompany = this.$route.query.is_company === 'yes' ? true : false
    setTimeout(() => {
      this.onLoad()
    },200)
    this.getPhone()
  },
  computed: {
    percentValue(){
      return parseInt(parseFloat(this.value)*100) + '%'
    },
  },
  mounted: function () {
    // this.handleCanvas();
    const navBarHeight = document.getElementsByClassName("relief-nav-bar")[0]
      .offsetHeight;
    const signBoxHeight = document.getElementById("signBox").offsetHeight;
    const warpperHeight = document.getElementById("signContract_warpper").offsetHeight;
    document.getElementById("contidract").style.height = warpperHeight - signBoxHeight - navBarHeight + "px";
    this.contidractStyle.height = document.body.clientHeight - (88 + 28 + 86) + 'px'
  },
  components: {
    navBar,
    pdf
  },
  methods: {
    getPhone(){
      this.$api.post('/debt/member/cert/get-mobile')
      .then(data => {
        this.phone = data.mobile
      })
      // this.phone = 13300000000
    },
    handleBusSignature(data){
      this.img_file = data.img_file
      this.img_name = data.img_name
      this.checkSign = true
    },
    goHome(){
      this.$router.push({
        path: '/debtRelief/wrDebtPersonHome',
        query: {
          token: localStorage.getItem('_token') || this.$route.query.token
        },
      })
    },
    stepperOnchange(){
      this.$nextTick(() => {
        // this.pdfStyle.width = this.percentValue
        this.pdfStyle.transform = `scale(${this.value})`
        // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
        this.$refs.pdfbox.style.display = 'none'
        // if (this.divSign1 instanceof HTMLElement) {
        //   // 本身需要缩小0.5，以0.5倍为基准
        //   this.divSign1.style.transform = `scale(${0.5 * this.value})`
        //   this.divSign1.style.bottom = `${80 * this.value}px`
        //   if (this.isCompany) {
        //     this.divSign1.style.left = `${(document.body.clientWidth - (60 + 180/2)) * this.value}px`
        //   } else {
        //     this.divSign1.style.left = `${60 * this.value}px`
        //   }
        // }
        this.isDisabled = true
        setTimeout(() => {
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = 'block'
        },10)
        setTimeout(() => {
          this.isDisabled = false
        },200)
      })
    },

    async pdfLoaded(i){
      // not last page
      if (this.numPages !== i) {
        return
      }


      let realName
      // 获取realName
      if (this.$route.query.identity === 'debtor') {
        const data = await this.$api.post("debt/member/debtor/info")
        if (data.debtor_type == 2) {
          realName = data.member_realname
          const param = {
            sign_unique:  data.member_unique,
            sign_subject: data.member_realname,
          }
          const res = await this.$api.post("/contract/member/contract/sign", param)
          this.seal_url = res.seal_url
          this.img_name = res.sign_logo
        } else {
          realName = data.member_realname
        }
      }
      if (this.$route.query.identity === 'creditor') {
        const param = {
          page: 1,
          size: 1,
        }
        const data = await this.$api.post("/debt/member/creditor/creditor-order/lists", param)
        realName = data.member_name
      }
      if (this.$route.query.identity === 'agent') {
        const param = {
          page: 1,
          size: 1,
        }
        const data = await this.$api.post("debt/member/agent/list", param)
        realName = data.member_realname
      }

      // 是否展示边框和提示
      // TODO 暂时是写死的
      const flag = true
      // const flag = ! this.checkSign

      // if (true) {
      //   const dom = this.$refs.pdfs[i-1].$el
      //   const dv1 = document.createElement('img')
      //   dv1.style.src = '../../assets/debtor/review.png'
      // }

      const dom = this.$refs.pdfs[i-1].$el
      const dv1 = document.createElement('div')
      const dv2 = document.createElement('div')
      const dv3 = document.createElement('img')
      const span1 = document.createElement('span')
      const span2 = document.createElement('span')
      const span3 = document.createElement('span')
      this.divSign1 = dv1
      this.divSign2 = dv2
      this.divSign3 = dv3

      // dv1.addEventListener('click', this.goSign)
      // <span class="dom">
      //   <div class="dv1">
      //     <div class="dv2"></div>
      //     <div class="dv3">
      //       <span1>请</span1>
      //       <span2>张三</span2>
      //       <span3>签名</span3>
      //     </div>
      //   </div>
      // </span>
      dom.appendChild(dv1)
      dv1.appendChild(dv2)
      dv1.appendChild(dv3)

      // style
      dv1.style.position = 'absolute'
      // TODO 签名和盖章位置写死的
      if (this.isCompany) {
        // 定位是bottom left，所以transform-origin 也需要是 bottom left，否则定位会有问题
        dv1.style['transform-origin'] = 'left bottom'
        dv1.style.bottom = '80px'
        dv1.style.left = document.body.clientWidth - (60 + 180/2) + 'px'
        dv1.style.width = '180px'
        dv2.style.height = '40px'
        dv3.style.height = '150px'
        // dv3.src = this.seal_url
        span3.innerText = '盖章'
        dv1.addEventListener('click', () => {
          // TODO 接口正常返回后替换
          dv3.src = this.seal_url
          // dv3.src = 'https://ng.ant.design/assets/img/logo.svg'
          this.checkSign = true
        })
        // if(this.$route.query.identity== 'debtor'){
        //   dv1.style.bottom = '659px'
        //   dv1.style.left = '140px'
        // }else if(this.$route.query.identity== 'creditor'){
        //   dv1.style.bottom = '415px'
        //   dv1.style.left = '140px'
        // }
      } else {
        // 定位是bottom left，所以transform-origin 也需要是 bottom left，否则定位会有问题
        dv1.style['transform-origin'] = 'left bottom'
        dv1.style.left = '60px'
        dv1.style.bottom = '80px'
        dv1.style.width = '180px'
        dv2.style.height = '30px'
        dv3.style.height = '90px'
        // TODO
        // dv3.src = 'https://ng.ant.design/assets/img/logo.svg'
        if (this.checkSign == true) {
          dv3.src = this.img_file
        }
        span3.innerText = '签名'
        dv1.addEventListener('click', this.goSign)
        
        // if(this.$route.query.identity== 'debtor'){
        //   dv1.style.bottom = '659px'
        //   dv1.style.left = '140px'
        // }else if(this.$route.query.identity== 'creditor'){
        //   dv1.style.bottom = '415px'
        //   dv1.style.left = '140px'
        // }else if(this.$route.query.identity== 'agent'){
        //   if(this.$route.query.shouldSign== 'agent'){
        //     dv1.style.left = '90px'
        //     dv1.style.bottom = '215px'
        //   }else if(this.$route.query.shouldSign== 'logo'){
        //     dv1.style.left = '100px'
        //     dv1.style.bottom = '30px'
        //   }
        // }
        if(this.$route.query.shouldSign== 'logo') {
          console.log("进入logo--------------------")
          dv1.style.left = '83px'
          dv1.style.bottom = '0px'
        }
      }
      // scale 基准值0.5
      dv1.style.transform = 'scale(0.5)'
      dv2.style.width = '100%'
      if (flag) {
        dv2.style.border = '1px dashed #fc740c'
        dv2.style['border-bottom'] = 'none'
        dv2.style['font-size'] = '16px'
        span1.innerText = '点'
        span2.innerText = '我'
        span2.style.color = '#fc740c'
        span1.style.color = '#fc740c'
        span3.style.color = '#fc740c'
        // span3.innerText = '签名'
        dv2.appendChild(span1)
        dv2.appendChild(span2)
        dv2.appendChild(span3)
      }

      dv3.style.width = '100%'
      if (flag) {
        dv3.style.border = '1px dashed #fc740c'
      }

      // this.$nextTick(() => {
      //   this.setScroll()
      // })
      setTimeout(() => {
        this.setScroll()
      },500)
      
    },
    // 合同滚到最后一页底部
    setScroll(){
      const parentDom = this.$refs.contidract
      const parentDomHeight = parentDom.getBoundingClientRect().height
      let sumHeight = 0
      for (let i = 0; i < parentDom.children.length; i++) {
        sumHeight += parentDom.children[i].getBoundingClientRect().height
      }

      const shouldScrollHeight = sumHeight - parentDomHeight
      parentDom.scrollTop = shouldScrollHeight
    },
    goSign(){
      this.$router.push({
        path: '/debtor/signature',
        query: {
          
        },
      })
    },
    goBack() {
      // this.params("", "", "goBack");
      this.$router.go(-1);
      // this.$router.push({
      //   path:'/debtRelief/wrDebtPersonHome',
      //   query:{
      //     token: localStorage.getItem('_token')
      //   }
      // })
    },
    onLoad() {
      this.$api
        .post("contract/member/contract/info", {
          contract_id: this.$route.query.contract_id,
        })
        .then((data) => {
          if (this.$route.query.identity === 'agent' && data.contract_status !== 1 && data.contract_status !== 2 && data.contract_status !== -3) {
            this.showDialog2 = true
            return
          }
          if (data.sign_file_url && data.sign_file_url.startsWith('http')) {
            this.pdfSrc = location.protocol+'//'+data.sign_file_url.split('//')[1] 
          } else {
            this.pdfSrc = location.protocol+'//'+data.base_file_url.split('//')[1]
          }
          if (this.pdfSrc) {
            this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
            this.pdfSrc.promise.then((pdf) => {
              this.numPages = pdf.numPages;
            });
          }
        })
        .catch(err => {
          console.log(err)
        });
    },
    handleSignClick() {
      this.show = true;
    },
    phoneConfirm() {
      // this.verigyPhone();
      // if (this.phontCorrect !== 1) {
      //   this.$toast("请填写正确的手机号");
      //   return
      // }
      if (this.msg == "") {
        this.$toast("验证码为空");
        return
      }
      // this.dialogShow = false
      this.submit();
    },
    //手机号验证
    verigyPhone() {
      if (this.phone == "") {
        this.$toast("请输入手机号");
      } else {
        if (/^1\d{10}$/.test(this.phone)) {
          this.phontCorrect = 1;
        } else {
          this.$toast("手机号格式错误");
          return false;
        }
      }
    },
    //短信验证
    getvarify() {
      if (this.getVerifyNum < 5) {
        this.getVerifyNum++;
        this.verigyPhone();
        const _this = this;
        if (this.phontCorrect == 1) {
          this.$api
            .post("/pushmsg/index/sms/send-code", {
              mobile: this.phone,
              type: 31,
            })
            .then((res) => {
              _this.down = 60;
              const timer = setInterval(function () {
                _this.down--;
                _this.downcounttime = 1;
                if (_this.down <= 0) {
                  clearInterval(timer);
                  _this.downcounttime = 0;
                }
              }, 1000);
              _this.$toast("验证码已发送，请注意查收");
            })
            .catch((err) => {
              console.log(err)
              this.$toast(err.message)
            });
        }
      } else {
        var current = Math.floor(new Date().getTime() / 1000);
        var tip = "";
        if (this.getVerifyNum == 5) {
          this.getVerifyNum++;
          this.stopGet = current + 60 * 15;
          //        this.$toast('获取验证码次数已超过5次，请过15分钟之后再试。')
        }
        var ts = this.stopGet - current;
        var mm = Math.floor(ts / 60);
        var ss = ts - mm * 60;
        if (mm && ss) {
          tip =
            "获取验证码次数已超过5次，请过" + mm + "分钟" + ss + "秒之后再试。";
        } else if (mm && !ss) {
          tip = "获取验证码次数已超过5次，请过" + mm + "分钟之后再试。";
        } else if (!mm && ss) {
          tip = "获取验证码次数已超过5次，请过" + ss + "秒之后再试。";
        }

        this.$toast(tip);
      }
    },

    async submit() {
      this.loading = true
      if (this.lock) {
        this.loading = false
        return
      }
      this.lock = true
      try {
        let param = {
          mobile: this.phone,
          code: this.msg,
          seal: this.img_name,
          order_id: this.$route.query.order_id,
        }

        if (this.$route.query.identity === 'creditor') {
          await this.$api.post('/debt/member/creditor/creditor-order/sign-role', param)
          this.$toast("签名成功")
          this.$router.push({
            path: '/debtor_creditor/resultSignature',
            query: {
              identity: this.$route.query.identity, //标识从哪个身份进入
              order_id: this.$route.query.order_id, //数据id
              contract_id: this.$route.query.contract_id, //数据id
            },
          })
          this.lock = false
          this.loading = false
          return
        }

        if (this.$route.query.identity === 'debtor') {
          await this.$api.post('/debt/member/debtor-order/sign-contract', param)
          
          this.$toast("签名成功")
          this.$router.push({
            path: '/debtor_creditor/resultSignature',
            query: {
              identity: this.$route.query.identity, //标识从哪个身份进入
              order_id: this.$route.query.order_id, //数据id
              contract_id: this.$route.query.contract_id, //数据id
            },
          })
          this.lock = false
          this.loading = false
          return
        }

        if (this.$route.query.identity === 'agent') {
          const param1 = {
            mobile: this.phone,
            code: this.msg,
          }
          // 成功，没有走catch即表示验证成功，可以继续提交签名
          await this.$api.post('debt/member/agent/validate',param1)

          let contract_id = this.$route.query.contract_id
          let sign_url = ''
          
          if (this.$route.query.shouldSign === 'agent') {
            sign_url = '/debt/member/agent/sign'
          }
          if (this.$route.query.shouldSign === 'logo') {
            sign_url = '/debt/member/agent/logo-sign'
          }

          const param2 = {
            contract_id: this.$route.query.contract_id,
            seal: this.img_name,
            // TODO 确定需要需要完整url，还是相对路径
            // url: '/debtRelief/businessDesc',
            url: `${location.origin}/debtRelief/businessDesc`,
          }
          await this.$api.post(sign_url, param2)
          this.$toast("签名成功")
          this.$router.push({
            path: '/agent/resultSign2',
            query:{
              gopage: -2,
              leavesigin:this.$route.query.leavesigin
            }
          })
          this.lock = false
          this.loading = false
          return
        }

        this.lock = false
        this.loading = false

      } catch (err) {
        console.log(err)
        if (err.code && err.code.length) {
          this.$toast(err.code[0])
        }else{
          this.$toast(err.message)
        }
        this.lock = false
        this.loading = false
      }

    },
    // handleInput() {
    //   if (/Android/gi.test(navigator.userAgent)) {
    //     window.addEventListener("resize", function () {
    //       window.setTimeout(function () {
    //         document.activeElement.scrollIntoView(false);
    //       }, 1);
    //     });
    //   }
    // },
  },
};
</script>
<style lang="less">
#signContract_warpper {
  // position: fixed;
  // top: 0;
  // left: 0;
  // height: 100%;
  // width: 100%;
  // box-sizing: border-box;
  // overflow-y: auto;
  // &::-webkit-scrollbar {
  //   display: none;
  // }
  // overflow: hidden;
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #fff;
  min-height: 100%;
  font-size: 16px;
  .contentBox {
    // overflow: auto;
  }
  #contidract {
    &::-webkit-scrollbar {
      display: none;
    }
    overflow: scroll;
    position: relative;
  }

  .stepper-warpper {
    height: 28px;
    position: relative;
    background-color: #fff;
    .van-stepper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .percent {
      position: absolute;
      height: 28px;
      line-height: 28px;
      width: 40px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      background-color: #f2f3f5;
      font-size: 13px;
    }
  }
  #signBox {
    padding-top: 12px;
    background-color: #f5f6f7;
    // height: 200px;
    #signNameCanvasBox {
      width: 100%;
      height: 98px;
      // margin-top: 6px;
      background: #fff;
      .signature {
        color: #f9591b;
        font-weight: 600;
        font-size: 20px;
        line-height: 98px;
        text-align: center;
      }
      .canvas {
        display: none;
      }
    }

    .complete {
      margin: 0 12px;
      padding-bottom: 24px;
      .operation_btn {
        background-color: #fc740c;
        color: #fff;
        border: none;
        width: 100%;
        margin: 0 auto;
        height: 50px;
        font-size: 17px;
        display: block;
        border-radius: 30px;
        line-height: 50px;
        font-weight: 600;
      }
    }
  }
  .verification_code {
    width: auto;
    border-radius: 6px;
    color: #ffffff;
    height: 38px;
    font-size: 16px;
    background-color: #fc740c;
    border: 1px solid #ebedf0;
  }
  .downcount {
    width: 100px;
    border-radius: 6px;
    color: #cccccc;
    height: 40px;
    font-size: 16px;
    background-color: #f5f6f7;
    border: 1px solid #ebedf0;
  }
  .codeBox {
    padding: 10px 16px 0;
    // border-bottom: 1px solid #f4f5f7;
  }
  .van-field__control {
    font-size: 16px;
  }
  .van-field__control:disabled {
    // color: #969799;
    color: #000;
    // -webkit-text-fill-color: #969799;
    -webkit-text-fill-color: #000;
    background-color: transparent;
    opacity: 1;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
  .van-dialog {
    width: 274px;
    border-radius: 3px;
    .van-dialog__content {
      .van-dialog__message {
        font-size: 16px;
        padding: 30px 49px;
      }
    }
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

}
</style>





